import { Shield } from "shield-js-npm";
import galileo from "./galileo";

// Initialize props to pass the site id and customize the JS url endpoint

const props = {
  siteId: process.env.REACT_APP_DEVICE_SHIELD_SITE_KEY,
};

export const handleShieldEnabled = () => {
  const shield = new Shield();
  return shield.init(props).then(() => {
    return shield
      .getDeviceIntelligence()
      .then((res) => {
        // retrieve session id
        const session_id = res.result.session_id;
        let deviceIntelligence = res.result.device_intelligence;

        if (process.env.NODE_ENV !== "production") {
          console.log("sheild--", session_id, process.env.NODE_ENV);
          console.log(deviceIntelligence);
        }
      })
      .catch((err) => {
        console.error("Error retrieving device intelligence:", err);
      });
  });
};

export const loadSheild = () => {
  return galileo.fetchIsSheildEnable().then((isEnabled) => {
    handleShieldStatus(isEnabled);
  });
};

export const handleShieldStatus = (isEnabled) => {
  if (isEnabled) {
    return handleShieldEnabled();
  } else {
    console.warn("Shield is not enabled.");
  }
};
